module.exports = __webpack_public_path__ + "img/colazione_6.e2050ebd.jpeg";